import { GapReportView } from './GapReportView';

export function LiquidityGapReportPage() {
  return (
    <GapReportView
      gapType="LIQUIDITY"
      title="Liquidity Gap report"
      description="Cash-flow timing gap by maturity bucket — shows how much liquidity is generated or consumed at each horizon over time."
      accent="liquidity"
    />
  );
}
